import { all_cities } from "./cityUtils";


export const genderFilters = (lang) => [
  {
    id: 0,
    name: lang?.community?.all_gender,
    value: 'all_gender',
  },
  {
    id: 1,
    name: lang?.community?.male,
    value: 'male',
  },
  {
    id: 2,
    name: lang?.community?.female,
    value: 'female',
  },
  {
    id: 3,
    name: lang?.common?.others,
    value: 'others',
  },
];

export const ageFilters = (lang) => [
  {
    id: 0,
    name: lang?.community?.all_age,
    value: 'all_age',
  },
  {
    id: 1,
    name: '18-24',
    value: '18-24',
  },
  {
    id: 2,
    name: '24-28',
    value: '24-28',
  },
  {
    id: 3,
    name: '28-40',
    value: '28-40',
  },
];

export const settingFilters = (lang) => [
  {
    id: 1,
    name: lang?.community?.all_relationship,
    value: 'all',
  },
  {
    id: 2,
    name: lang?.community?.open_relationship,
    value: 'open_relationship',
  },
  {
    id: 3,
    name: lang?.community?.serious_relationship,
    value: 'serious_relationship',
  },
];

export const figureFilters = (lang) => [
  {
    id: 1,
    name: lang?.community?.all_figure,
    value: 'all',
  },
  {
    id: 2,
    name: lang?.community?.thin,
    value: 'thin',
  },
  {
    id: 3,
    name: lang?.community?.normal,
    value: 'normal',
  },
  {
    id: 4,
    name: lang?.community?.wrapped,
    value: 'wrapped',
  },
  {
    id: 5,
    name: lang?.community?.very_wrapped,
    value: 'very_wrapped',
  },
];

export const sort_data = (lang) => [
  {
    id: 1,
    name: lang?.community?.sorting_high_low,
    value: 'high_low',
  },
  {
    id: 2,
    name: lang?.community?.sorting_low_high,
    value: 'low_high',
  },
];

export const starSignFilters = (lang) => [
  { id: 'all', name: lang?.community?.all_signs },
  { id: 'ram', name: lang?.community?.ram },
  { id: 'bull', name: lang?.community?.bull },
  { id: 'gemini', name: lang?.community?.gemini },
  { id: 'cancer', name: lang?.community?.cancer },
  { id: 'lion', name: lang?.community?.lion },
  { id: 'virgin', name: lang?.community?.virgin },
  { id: 'balance', name: lang?.community?.balance },
  { id: 'scorpio', name: lang?.community?.scorpio },
  { id: 'sagittarius', name: lang?.community?.sagittarius },
  { id: 'capricorn', name: lang?.community?.capricorn },
  { id: 'aquarius', name: lang?.community?.aquarius },
  { id: 'fish', name: lang?.community?.fish },
];

export const cityFilters = (lang) => [
  { id: 9999, name: lang?.community?.all_city, value: 'all_city' },
  ...all_cities
];
